export enum ComparisonSelection {
    SquadPlayers,
    PersonalBest,
    AcademyPlayers,
    ProPlayers
}
